<!-- HEADER -->
<div class="header flex justify-content-between lg:flex-nowrap flex-wrap bg-white">
  <!--<div flex flex-wrap>
    <img class="logo" src="./assets/icons/logo.png" />-->
  <!-- <h4 class="staging-header">ΔΟΚΙΜΑΣΤΙΚΟ ΠΕΡΙΒΑΛΛΟΝ</h4> -->
  <!--</div>-->

  <div class="flex gap-3 align-content-end align-items-center">
    <img class="logo" src="./assets/icons/logo_top.png" />
    <div class="mb-10">
      <h2>{{ appTitle }}</h2>
      <h4>{{ appSubtitle }}</h4>
    </div>
  </div>
</div>
<hr class="shadow-1"/>

<div class="stage-message" *ngIf="isStageEnvironment">
  <i class="pi pi-info-circle"></i> ΔΟΚΙΜΑΣΤΙΚΟ ΠΕΡΙΒΑΛΛΟΝ
</div>

<!-- BODY -->
<div class="flex justify-content-center min-height-50">
  <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <!-- @if (errorMessages || alertMessage) {
    <p-messages [(value)]="errorMessages" [enableService]="false" />
    <p-messages *ngIf="" [(value)]="alertMessage" [enableService]="false" />
    } -->

    <div class="flex flex-column gap-4 mt-6 p-5 border-round surface-card shadow-1">

      <div class="text-3xl mx-2 mb-5 mx-5">Εισάγετε τα στοιχεία χρήστη</div>

      <eo-input
        label="Όνομα Χρήστη"
        type="text"
        formControlName="username"
        [errors]="authFormConfig.getErrors('username')"
      />

      <eo-input
        label="Κωδικός"
        type="password"
        formControlName="password"
        [errors]="authFormConfig.getErrors('password')"
      />

      <button
        pButton
        type="submit"
        label="Είσοδος στην Υπηρεσία"
        iconPos="right"
        class="p-button-primary"
        [disabled]="
          !form.valid ||
          (status$ | async) === 'loading'
        "
        [loading]="(status$ | async) === 'loading'"
      ></button>
        
      <!-- <button
        pButton
        type="submit"
        label="Εγγραφή με ΓΓΠΣ (Taxis)"
        class="p-button-text"
        iconPos="right"
        [disabled]="
          (status$ | async) === 'loading_register' ||
          (status$ | async) === 'loading'
        "
        [loading]="(status$ | async) === 'loading_register'"
        (click)="OnRegister()"
      ></button> -->
    </div>
  </form>

  <!--<div class="form-container">
      <h2 style="margin: 30px 0 0 0px">Ανακοινώσεις</h2>
      <h4 *ngIf="announcements.length === 0" style="width: 640px">
        Δεν υπάρχουν ανακοινώσεις
      </h4>
      <p-messages
        [(value)]="announcements"
        [enableService]="false"
        [closable]="false"
      ></p-messages>
    </div>-->
</div>

<!-- FOOTER -->
<div class="flex justify-content-between layout-footer">
  <p>
    Διεύθυνση Ηλεκτρονικής Διακυβέρνησης ΕΚΑΠΥ © 2024. Version
    {{ appVersion }}
  </p>
  <img style="padding-right: 180px;" src="./assets/icons/ellada2.png" alt="Ellada Logo" />
  <p>{{ today }}</p>
</div>